// Index page for website 🚀

import React, { useState, useEffect } from "react";
import { Footer, Belowbanner, HeroBanner, Navbar, Product, Loading, Divider } from "./components";
import { client } from "./lib/client";

const Home = () => {
  const [bannersData, setBanner] = useState([]);
  const [carsData, setCar] = useState([]);
  const [cartype, setCartype] = useState("all");

  useEffect(() => {
    async function fetchBannerData() {
      console.log("before", cartype);
      const bannerQuery = '*[_type =="banner" ]';
      let carQuery = '*[_type =="car" && cartype == "all"]';
      if (cartype === "suv") {
        carQuery = '*[_type =="car" && cartype == "suv"]';
      } else if (cartype === "sedan") {
        carQuery = '*[_type =="car" && cartype == "sedan"]';
      } else if (cartype === "coupe") {
        carQuery = '*[_type =="car" && cartype == "coupe"]';
      } else if (cartype === "muscle") {
        carQuery = '*[_type =="car" && cartype == "muscle"]';
      } else if (cartype === "offroad") {
        carQuery = '*[_type =="car" && cartype == "offroad"]';
      } else if (cartype === "sport") {
        carQuery = '*[_type =="car" && cartype == "sport"]';
      } else if (cartype === "supercars") {
        carQuery = '*[_type =="car" && cartype == "supercars"]';
      } else if (cartype === "all") {
        carQuery = '*[_type =="car"]';
      } else if (cartype === "bikes") {
        carQuery = '*[_type =="car" && cartype == "bikes"]';
      }
      Promise.all([await client.fetch(bannerQuery), await client.fetch(carQuery)]).then((data) => {
        const banner = data[0];
        const cars = data[1];
        setCar(cars);
        setBanner(banner);
      });
    }
    fetchBannerData();
    console.log("chenaged", carsData, cartype);
  }, [cartype]);

  return (
    <>
      <Navbar />
      {bannersData[0] ? (
        <div>
          <HeroBanner heroBannerData={bannersData.length && bannersData[0]} />
          <Divider />
          <div className="products-heading">
            <h2>Best Selling Cars</h2>
            <p>Cars of many variations and prices</p>
          </div>
          <form className="car-type-form" id="cars">
            <select
              name="card-select"
              id="card-select"
              onChange={(e) => {
                setCartype(e.target.value);
              }}
            >
              <option value="all">Select Car Type</option>
              <option value="all">ALL</option>
              <option value="suv">SUVS</option>
              <option value="sedan">SEDANS</option>
              <option value="coupe">COUPES</option>
              <option value="muscle">MUSCLE</option>
              <option value="offroad">OFFROAD</option>
              <option value="sport">SPORTS</option>
              <option value="supercars">SUPERCARS</option>
              <option value="bikes">BIKES</option>
            </select>
          </form>
          {carsData.length > 0 ? (
            <>
              <div className="products-container">
                {carsData?.map((car) => (
                  <Product key={car._id} product={car} />
                ))}
              </div>
              <div className="center-div">
                <a href="https://discord.com/channels/784794493580476436/1022406330834755594">
                  <button className="click-button">Book Now in Discord</button>
                </a>
              </div>
            </>
          ) : (
            <Loading message="Cars Coming Soon, Until then grab a cup of coffee 🍵" />
          )}
          <Divider />
          <div id="about">
            <Belowbanner footerBanner={bannersData && bannersData[1]} />
          </div>
          <Divider />
          <Footer />
        </div>
      ) : (
        <Loading message="Screen Loading" />
      )}
    </>
  );
};

export default Home;
